import { render, staticRenderFns } from "./fenrun.vue?vue&type=template&id=231f76fd&scoped=true"
import script from "./fenrun.vue?vue&type=script&lang=js"
export * from "./fenrun.vue?vue&type=script&lang=js"
import style0 from "./fenrun.vue?vue&type=style&index=0&id=231f76fd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "231f76fd",
  null
  
)

export default component.exports